import Vue from 'vue' //manggil Vue nya 
import App from './App.vue' //manggil file app.vue
import '@/plugins/axios' // manggil librari ajax yang namanya axios
import '@/plugins/bootstrap-vue' //manggil librari bootstrap
// import router from './router'

Vue.config.productionTip = process.env.VUE_APP_ENV === 'development' ? true : false

new Vue({
  // router,
  render: h => h(App)
}).$mount('#app')
